import { Linkedin, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.91l-5.41-7.07L3.99 22H.73l8.02-9.17L.5 2h7.08l4.89 6.46L18.244 2Zm-1.21 18h1.8L7.04 3.9H5.1L17.03 20Z" />
  </svg>
);

export const articleUrl = (slug) => `${window.location.origin}/insights/${slug}`;

export const ShareButtons = ({ article, compact = false }) => {
  const url = articleUrl(article.slug);
  const text = `${article.title} — AiCendor`;
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  const x = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard.");
    } catch (_) {
      toast.error("Couldn't copy — please copy the address bar URL.");
    }
  };

  const base = "flex items-center gap-2 border px-3 py-2 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors";
  const idle = "border-white/15 text-slate-300 hover:border-gold hover:text-gold";

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`share-buttons-${article.slug}`}>
      {!compact && (
        <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
          <Share2 className="h-3.5 w-3.5" /> Share
        </span>
      )}
      <a href={linkedin} target="_blank" rel="noreferrer" data-testid={`share-linkedin-${article.slug}`} aria-label="Share on LinkedIn" className={`${base} ${idle}`}>
        <Linkedin className="h-3.5 w-3.5" /> LinkedIn
      </a>
      <a href={x} target="_blank" rel="noreferrer" data-testid={`share-x-${article.slug}`} aria-label="Share on X" className={`${base} ${idle}`}>
        <XIcon className="h-3.5 w-3.5" /> X
      </a>
      <button type="button" onClick={copy} data-testid={`share-copy-${article.slug}`} className={`${base} ${idle}`}>
        <Link2 className="h-3.5 w-3.5" /> Copy link
      </button>
    </div>
  );
};
